import React from 'react';

const AgentTemplateConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/templateMessage-individual-user',
			component: React.lazy(() => import('../TemplateMessages/Template'))
	}
	]
};

export default AgentTemplateConfig;
